import { Injectable, Optional, SkipSelf } from '@angular/core';
import { Promise } from 'q';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

    constructor(@Optional() @SkipSelf() prior: ModalService) {
        if (prior)
            return prior;
    }

    activate: (message?: string, title?: string, okText?: string, cancelText?: string, showCopyButton?: boolean) => Promise<boolean>;
}
